module.exports = __webpack_public_path__ + "assets/img/files-folder.cee62ff5.svg";